import { FC } from 'react'
import { OPTIONS } from './consts'
import * as Styled from './styled'
import { CrownIcon } from 'containers/SubSidebar/styled'

interface IExportOptionsProps {
  onExport: (quality: number) => void
  allowedQualities: number[]
}

const ExportOptions: FC<IExportOptionsProps> = ({
  onExport,
  allowedQualities
}) => (
  <Styled.ExportDropdownContent>
    {OPTIONS.map(item => (
      <Styled.ExportOption key={item.id} onClick={() => onExport(item.id)}>
        <Styled.OptionHeader>
          {item.label}{' '}
          {!allowedQualities.includes(item.id) ? (
            <Styled.CrownBadgeIcon
              icon={<CrownIcon />}
              size="small"
              color="goldDark"
            />
          ) : null}
        </Styled.OptionHeader>
        <Styled.OptionDescription>{item.description}</Styled.OptionDescription>
      </Styled.ExportOption>
    ))}
  </Styled.ExportDropdownContent>
)

export default ExportOptions
